import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppStateFacade } from '@app-state';
import {
    IQueueItemComment,
    ODataResponse,
} from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const NAMESPACE = 'UiPath.Server.Configuration.OData';
@Injectable()
export class QueueItemCommentService extends ODataService<IQueueItemComment, number> {
    protected _endpoint: string;

    constructor(
        http: HttpClient,
        { authConfig }: AppStateFacade,
    ) {
        super(http, MapperService.queueItemCommentMap);
        this._endpoint = `${authConfig.odataBaseUrl}/QueueItemComments`;
    }

    public getByItem(queueItemId: number) {
        return this._http.get(
            `${this._endpoint}/${NAMESPACE}.GetQueueItemCommentsHistory(queueItemId=${queueItemId})?$orderby=CreationTime desc`,
        )
            .pipe(
                map(response => this._mapData(response)),
            ) as Observable<ODataResponse<any>>;
    }
}
